<template>
  <date-picker
    @change="emit()"
    class="eda-styled-date"
    :class="{'eda-styled-date--invisible': !visible}"
    :range="range"
    :shortcuts="false"
    :first-day-of-week="1"
    input-class="eda-styled-date__input"
    format="D/M YYYY"
    v-model="pickerValue"
    :lang="lang"
    @clear="$emit('clear')" />
</template>

<script>
import DatePicker from 'vue2-datepicker';

export default {
  name: "EdaStyledDateInput",
  components: {
    DatePicker
  },
  props: {
    value: { type: [Object, String, Array], default: new Date() },
    visible: { type: Boolean, default: true },
    range: { type: Boolean, default: false },
    lang: {
      type: Object, default: function () {
        return {
          days: [
            this.$t('datePicker.sunday'),
            this.$t('datePicker.monday'),
            this.$t('datePicker.tuesday'),
            this.$t('datePicker.wednesday'),
            this.$t('datePicker.thursday'),
            this.$t('datePicker.friday'),
            this.$t('datePicker.saturday'),
          ],
          months: [
            this.$t('datePicker.january'),
            this.$t('datePicker.february'),
            this.$t('datePicker.march'),
            this.$t('datePicker.april'),
            this.$t('datePicker.may'),
            this.$t('datePicker.june'),
            this.$t('datePicker.july'),
            this.$t('datePicker.august'),
            this.$t('datePicker.september'),
            this.$t('datePicker.october'),
            this.$t('datePicker.november'),
            this.$t('datePicker.december'),
          ],
          pickers: ['neste 7 dager', 'neste 30 dager', 'siste 7 dager', 'siste 30 dager'],
          placeholder: {
            date: this.$t('datePicker.pickADate'),
            dateRange: this.$t('datePicker.pickDateRange'),
          }
        };
      }
    }
  }
  ,
  data () {
    return {
      pickerValue: this.value
    };
  }
  ,
  methods: {
    emit () {
      this.$emit('input', this.pickerValue);
    }
  }
};
</script>

<style>
.eda-styled-date {
  width: 100%;
  transition: all 0.2s cubic-bezier(.5, 0, 0, 1);
}

.eda-styled-date--invisible {
  opacity: 0;
  margin: 0;
}

.eda-styled-date__input {
  width: 100%;
  padding: 0.85em 2.5em 0.85em 1.5em;
  border-radius: 3em;
  background-color: #EFEFEF;
  border: none;
  font-size: 1.1em;
  transition: all 0.2s cubic-bezier(.5, 0, 0, 1);
}

.eda-styled-date__input::placeholder {

  color: #B5B5B5;
}

.eda-styled-date--invisible
.eda-styled-date__input {
  padding-top: 0;
  padding-bottom: 0;
  max-height: 0;
}


</style>
